import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseComponent, WmsToggleComponent, WmsTypeaheadComponent } from '@wms/app/components';
import { CheckboxsetComponent, EventHandlerComponent } from '@wms/properties-panel';
import { LiveWidgetSettingsService } from '@wms/app/services/liveWidgetsSettings/live-widget-settings.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { indexOf, findIndex } from 'lodash-es';
import { WmsExpressionErrorDirective } from '@wms/app/directives/wms-expression-error/wms-expression-error.directive';

@Component({
  selector: 'wms-actions-basic',
  standalone: true,
  templateUrl: './actions-basic.component.html',
  styleUrls: ['./actions-basic.component.less'],
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule,
    WmsTypeaheadComponent,
    CheckboxsetComponent,
    WmsToggleComponent,
    EventHandlerComponent,
    WmsExpressionErrorDirective
  ]
})
export class ActionsBasicComponent extends BaseComponent implements OnInit {

  @Input() selectedcomponent!: any;
  @Input() rowactionspositions!: any;
  @Output() validateAndUpdateExpression = new EventEmitter<any>();
  property: any;
  liveWidgetSettingsService: LiveWidgetSettingsService;
  indexOf = indexOf;
  isArray = Array.isArray;

  constructor() {
    super();
    this.liveWidgetSettingsService = inject(LiveWidgetSettingsService)
  }

  ngOnInit(): void {
  }

  handlePositionChange(val: any) {
    this.liveWidgetSettingsService.selectedComponent.button.position = val;
  }

  onToggleChange(value: any) {
    this.selectedcomponent.button.disabled = value;
  }

  onSelectedCompChange(componentType: 'field' | 'button', selectedKey: string, value: any) {
    this.liveWidgetSettingsService.selectedComponent[componentType][selectedKey] = value;
    // let field = this.liveWidgetSettingsService.selectedComponent[componentType];
    // let index = findIndex(this.liveWidgetSettingsService.componentDefnObject[componentType], (comp: any) => comp.key === field.key);
    // this.liveWidgetSettingsService.componentDefnObject[componentType][index] = field;

    let field = this.liveWidgetSettingsService.selectedComponent[componentType];
    let index = findIndex(this.liveWidgetSettingsService.componentDefnObject[componentType], (comp: any) => comp.key === field.key);
    this.liveWidgetSettingsService.componentDefnObject[componentType][index] = field;
  }

}
